"use strict";

angular.module("vendor")
.controller("ShippingRateListController", function(
    $scope, ShippingRateService, ZoneService, SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
) {
    var _this = this;

    $scope.shippingRates = [];
    this.PER_REGION_AND_WEIGHT = SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT;

    $scope.localizedMethods = ShippingRateService.getShippingRateMethodTranslations();
    var unregisterLanguageChanged = $scope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        $scope.localizedMethods = ShippingRateService.getShippingRateMethodTranslations();
    });
    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
    });

    ShippingRateService.query().$promise.then(function(data) {
        $scope.shippingRates = data;
        angular.forEach($scope.shippingRates, function(shippingRate) {
            if (shippingRate.method === SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT && shippingRate.zone_keys) {
                _this.setShippingRateRegions(shippingRate);
            }
        });
    });

    this.setShippingRateRegions = function(shippingRate) {
        ZoneService.retrieveZones(shippingRate.zone_keys).then(function onSuccess(response) {
            shippingRate.regions = response.data;
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/shipping-rate/shipping-rate-list.controller.js
// module id = 1015
// module chunks = 0